import { render, staticRenderFns } from "./CogneetivData.vue?vue&type=template&id=ec45c72a&"
import script from "./CogneetivData.vue?vue&type=script&lang=js&"
export * from "./CogneetivData.vue?vue&type=script&lang=js&"
import style0 from "./CogneetivData.vue?vue&type=style&index=0&id=ec45c72a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports